import { makeStyles } from "@material-ui/core";

export const useRequestDialogStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: 12,
      width: "100%",
      maxWidth: 748,
      padding: "24px",
      [theme.breakpoints.down(600)]: {
        margin: "16px",
      },
    },
  },
  dialogTitle: {
    textAlign: "left",
    padding: "0px",
    paddingBottom: "20px",
    "& .MuiTypography-h6": {
      fontSize: "24px",
      fontWeight: 700,
      color: "#333",
      lineHeight: "32px",
    },
  },
  dialogContent: {
    padding: "0px",
  },
  formRow: {
    display: "flex",
    gap: "16px",
    marginBottom: "24px",
    alignItems: "flex-start",
    [theme.breakpoints.down(600)]: {
      flexWrap: "wrap",
    },
  },
  formGroup: {
    flex: 1,
    minWidth: "150px",
  },
  label: {
    fontSize: "1rem",
    fontWeight: 500,
    color: "#333",
    marginBottom: "8px",
    display: "block",
  },
  requiredStar: {
    color: "#e53935",
  },
  select: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#ddd",
      },
      "&:hover fieldset": {
        borderColor: "#999",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiSelect-select": {
      padding: "12px 30px 12px 14px",
      fontSize: "1rem",
      color: "#666",
    },
  },
  addButton: {
    marginTop: "8px",
    padding: "4px 16px",
    borderRadius: 4,
    backgroundColor: "#fff",
    border: "2px solid #4760FF",
    color: "#4760FF",
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      borderColor: "#3348cc",
      color: "#3348cc",
      opacity: "0.8",
    },
  },
  addIcon: {
    marginLeft: "8px",
    fontSize: "1.2rem",
  },
  dialogActions: {
    padding: "24px 24px 0px 24px",
    justifyContent: "center",
    gap: "16px",
  },
  cancelButton: {
    padding: "12px 24px",
    borderRadius: 8,
    backgroundColor: "#fff",
    border: " 2px solid #E6E6E6",
    boxShadow: "0px 2px 4px 0px #00000014",
    color: "#404040",
    textTransform: "capitalize",
    fontSize: "1rem",
    minWidth: 120,
    "&:hover": {
      opacity: "0.7",
    },
  },
  submitButton: {
    padding: "12px 24px",
    borderRadius: 8,
    backgroundColor: "#DD672C",
    boxShadow: "0px 2px 4px 0px #00000014",
    color: "#fff",
    textTransform: "capitalize",
    fontSize: "1rem",
    minWidth: 120,
    fontWeight: 700,
    "&:hover": {
      opacity: "0.7",
      backgroundColor: "#DD672C",
    },
  },
  courseRow: {
    marginBottom: "16px",
  },
}));

export const useCoursesStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  title: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "42px",
    lineHeight: "48px",
    fontWeight: 700,
    color: "#404040",
    letterSpacing: "-4%",
    marginBottom: "32px",
    [theme.breakpoints.down(900)]: {
      fontSize: "24px",
      marginBottom: "8px",
    },
  },
  titleHighlight: {
    color: "#C79000",
    position: "relative",
  },
  titleHighlightImg: {
    position: "absolute",
    bottom: "-14px",
    left: "50px",
    width: "67px",
    height: "auto",
    [theme.breakpoints.down(800)]: {
      left: "20px",
      bottom: "-8px",
      width: "40px",
    },
  },
  courseWrapper: {
    "& > div:first-child": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },

    "& > .header > p": {
      fontSize: "20px",
      fontWeight: 700,
      color: "#3D3D3D",
      fontFamily: "'Inter', sans-serif",
    },

    "& .cardContainer": {
      marginTop: "20px",
      display: "grid",
      gap: "24px",
      justifyContent: "center",
      gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))",
      maxHeight: "500px",
      overflowY: "auto",
      // padding: "0 10px 20px",
    },

    "& .cardContainer .mentorCourseCard": {
      width: "100%",
      maxWidth: "390px",
      minHeight: "132px",
      border: "2px solid #E6E6E6",
      borderRadius: "16px",
      background: "#F8F8F8",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },

    "& .cardContainer .mentorCourseCard .cardTop": {
      background: "#f8f8f8f",
      padding: "16px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "12px",
      flex: 1,
    },

    "& .cardContainer .mentorCourseCard .cardTop > img": {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      flexShrink: 0,
    },

    "& .cardContainer .mentorCourseCard .cardTop .courseName": {
      fontFamily: "'Inter', sans-serif",
      fontSize: "16px",
      fontWeight: 600,
      color: "#1A1A1A",
      lineHeight: "20px",
      textTransform: "capitalize",
      margin: 0,
      marginTop: "6px",

    },

    "& .cardContainer .mentorCourseCard .cardBottom": {
      padding: "16px 16px",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      backgroundColor: "#fff",
    },

    "& .cardContainer .mentorCourseCard .cardBottom .curriculumLink": {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "'Inter', sans-serif",
      color: "#3366FF",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },

    "& .cardContainer .mentorCourseCard .cardBottom .curriculumLink .arrow": {
      fontSize: "13px",
      lineHeight: 1,
    },
    "& .courseImg": {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      flexShrink: 0,
      marginTop: "-4px",
    },
  },

  requestCourseCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#F5F5F5",
    border: "1px solid #C4C4C4",
    width: "100%",

    marginTop: "20px",

    minHeight: "150px",
    padding: "16px",
    borderRadius: "4px",
    cursor: "pointer",
    "& > p": {
      color: "#666666",
      fontSize: "14px",
      fontFamily: "Roboto",
    },
  },

  requestCourseBtn: {
    [theme.breakpoints.down("xs")]: {
      marginTop: "6px !important",
    },
  },
}));
